import React, { useEffect, useState, useRef } from 'react';
import { Tooltip, Tag, Icon, Empty, Spin } from 'antd';
import useInfoBinds from '../../../../queries/useInfoBinds';
import CompanyBinds from '../CompanyBinds/CompanyBinds';
import HouseBinds from '../HouseBinds/HouseBinds';
import RoomBinds from '../RoomBinds/RoomBinds';
import BindsForm from '../BindsForm/BindsForm';
import { useBindsData } from './hooks';
import styles from './BindsContainer.module.scss';

const BindsContainer = ({ infoId }) => {
  const [isFormVisible, setIsFormVisible] = useState(false);

  const formRef = useRef();

  const { data: serverBinds, isFetching: isBindsFetching } = useInfoBinds(
    infoId,
    {
      enabled: Boolean(infoId),
    }
  );

  const { companyBinds, houseBinds, roomBinds, initFormState, prevBinds } =
    useBindsData(serverBinds);

  useEffect(() => {
    if (isFormVisible && formRef.current) {
      formRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  }, [isFormVisible]);

  useEffect(() => {
    if (isFormVisible) {
      setIsFormVisible(false);
    }
  }, [infoId]);

  const handleAddBindingClick = () => {
    setIsFormVisible((prev) => !prev);
  };

  return (
    <Spin spinning={isBindsFetching}>
      <div className={styles.root}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            <Icon type="link" /> Привязки
          </h2>
          <Tooltip
            title={
              isFormVisible
                ? 'Закрыть форму'
                : serverBinds?.length
                ? 'Изменить привязки'
                : 'Добавить привязки'
            }
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            <Tag
              color="#0995ed"
              className={styles.addBindingBtn}
              onClick={handleAddBindingClick}
            >
              <Icon
                type={isFormVisible ? 'close' : 'link'}
                className={styles.addBindingIcon}
              />
            </Tag>
          </Tooltip>
        </div>
        {isFormVisible ? (
          <BindsForm
            initState={initFormState}
            ref={formRef}
            onCancel={() => setIsFormVisible(false)}
            binds={{ companyBinds, houseBinds, roomBinds }}
            prevBinds={prevBinds}
          />
        ) : (
          <>
            {!serverBinds?.length && (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Нет привязок"
                className={styles.emptyBlock}
              />
            )}
            {serverBinds?.length > 0 && (
              <>
                {companyBinds.length > 0 && (
                  <CompanyBinds binds={companyBinds} />
                )}
                {houseBinds.length > 0 && <HouseBinds binds={houseBinds} />}
                {roomBinds.length > 0 && <RoomBinds binds={roomBinds} />}
              </>
            )}
          </>
        )}
      </div>
    </Spin>
  );
};

export default BindsContainer;
